import React from "react";

import { faPlus } from "@fortawesome/pro-regular-svg-icons";

import { Button } from "src/design-system/Button";

export const AddConditionButton: React.FC<{
  immutable: boolean;
  onClick: () => void;
}> = ({ immutable, onClick }) => (
  <div className="mt-2 inline-block">
    <Button
      dataLoc="add-condition"
      isDisabled={immutable}
      iconLeft={faPlus}
      size="sm"
      variant="secondary"
      onClick={onClick}
    >
      Add condition
    </Button>
  </div>
);
